// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2P5mx","title":"BackImages_title__1qUBO","images":"BackImages_images__d-Vme"};